import Topheader from "./components/header/top-header";
import Bottompart from "./components/header/bottom-part";
import { FooterSection } from "./components/footer";
import ArzRouter from "./router";
import { BrowserRouter as Router } from "react-router-dom";
import { ModatCart } from "./components/modalCart";
import Header from "./components/header/header";
import "./App.css";

export default function App() {
  return (
    <Router>
      <div  >
        {/* <Header /> */}
        <ArzRouter />
        {/* <FooterSection /> */}
        {/* <ModatCart /> */}
      </div>
    </Router>
  );
}
